export default __webpack_public_path__ + "media/images/svg/lock-icon-33acaddbedfaaf62698333ba6c8c6681.svg";